module.exports = "/images/ico-paypo.svg?28a9229b9f0ba82e52f3a4345fcf921d";